import React from "react";

const PROTEIN_GOAL_PER_MEAL = 30;

const meals = ["Breakfast", "Snack 1", "Lunch", "Snack 2", "Dinner"];

const ProteinDashboard = ({ user }) => {
  let log = JSON.parse(localStorage.getItem("custom.hyman_hive_log")) || {};

  const getDateStrFromDate = (date) => {
    const local = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    return local.toISOString().split("T")[0];
  };

  let today = new Date();
  const todayStr = getDateStrFromDate(today);
  const todayLog = Object.values(log || {}).find(
    (entry) => entry.date === todayStr
  );

  const checklist = meals.map((meal) => {
    const mealEntry = todayLog?.entries?.[meal];
    const proteinArray = mealEntry?.protein || [];
    const gramsLogged = proteinArray.reduce((acc, cur) => acc + cur.grams, 0);
    const isLogged = gramsLogged > 0;
    const percentage = Math.min(
      (gramsLogged / PROTEIN_GOAL_PER_MEAL) * 100,
      100
    );

    return (
      <li
        key={meal}
        className="tw-grid tw-grid-cols-[75px_1fr_auto] tw-items-center tw-gap-6 tw-py-2"
      >
        <span className="tw-text-sm lg:tw-text-base tw-font-medium">
          {meal}
        </span>
        <div className="tw-h-4 tw-rounded-full tw-bg-gray-200">
          <div
            className="tw-h-full tw-rounded-full tw-bg-green-500"
            style={{ width: `${percentage}%` }}
          />
        </div>

        <span
          className={`tw-h-6 tw-w-6 tw-flex tw-items-center tw-justify-center tw-rounded-full ${
            isLogged
              ? `tw-bg-green-500 tw-text-white dark:tw-text-black`
              : `tw-bg-gray-300 tw-text-white dark:tw-text-black`
          }`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="tw-h-4 tw-w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={3}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </span>
      </li>
    );
  });

  return (
    <>
      <div className="tw-w-full tw-bg-white dark:tw-bg-black tw-px-6 sm:tw-px-8 tw-py-8 tw-rounded-2xl tw-shadow-sm">
        <h3 className="tw-text-lg tw-font-semibold dark:tw-text-white">
          Protein Tracker: What’s Left to Log Today?
        </h3>
        <ul className="tw-text-gray-500 tw-mt-4 tw-text-sm tw-space-y-1">
          {checklist}
        </ul>
      </div>
    </>
  );
};

export default ProteinDashboard;
